/**
 * Time Calculations - Pure functions for time and duration calculations
 *
 * This module provides Level 5 pure functions for calculating durations,
 * processing times, and time-based metrics.
 */

/**
 * Calculates elapsed time in milliseconds
 * @param startTime - Start timestamp (from Date.now())
 * @param endTime - End timestamp (from Date.now()), defaults to current time
 * @returns Elapsed time in milliseconds
 * @pure Level 5 calculation - no side effects
 */
export function calculateElapsedTime(startTime: number, endTime: number = Date.now()): number {
  return endTime - startTime;
}

/**
 * Calculates processing time in seconds
 * @param startTime - Start timestamp (from Date.now())
 * @param endTime - End timestamp (from Date.now())
 * @returns Processing time in seconds
 * @pure Level 5 calculation - no side effects
 */
export function calculateProcessingTimeSeconds(
  startTime: number,
  endTime: number = Date.now()
): number {
  return (endTime - startTime) / 1000;
}

/**
 * Calculates years between periods for interest calculations
 * @param currentPeriod - Current period/year
 * @param startPeriod - Starting period/year
 * @param adjustment - Additional adjustment (default 1 for inclusive counting)
 * @returns Number of years between periods
 * @pure Level 5 calculation - no side effects
 */
export function calculateYearsBetween(
  currentPeriod: number,
  startPeriod: number,
  adjustment: number = 1
): number {
  return currentPeriod - startPeriod + adjustment;
}
